import type { FC } from 'react';
import type { ParsedPlateEditorValue } from '@/utils/parsing.utils';
import { useTranslations } from 'next-intl';
import { PlateViewer } from 'packages/plate-viewer/src';
import { GameTabsMap } from '../utils/detailed-game.utils';

interface AboutGameProps {
  contentValue: ParsedPlateEditorValue;
}

export const AboutGame: FC<AboutGameProps> = ({ contentValue }) => {
  const t = useTranslations('game');

  return (
    <section id={GameTabsMap.about.id} className="max-w-200">
      <h3 className="text-xl leading-[1.4] font-medium mb-6 text-light">{t('game-details.about-game')}</h3>
      <PlateViewer value={contentValue} className="flex flex-col gap-2" />
    </section>
  );
};
